// Auth
export const DRIVER_SIGN_IN = 'DRIVER_SIGN_IN'
export const DRIVER_SIGN_OUT = 'DRIVER_SIGN_OUT'
export const DRIVER_SWITCH_TENANT = 'DRIVER_SWITCH_TENANT'

export const DRIVER_APP_MENU_KEY = 'DRIVER_APP_MENU_KEY'
export const DRIVER_RESET_APP_MENU_KEY = 'DRIVER_RESET_APP_MENU_KEY'

export const DRIVER_DASHBOARD_MANIFEST_PAGINATION = 'DRIVER_DASHBOARD_MANIFEST_PAGINATION'
export const DRIVER_DASHBOARD_MANIFEST_CONDITION = 'DRIVER_DASHBOARD_MANIFEST_CONDITION'
export const DRIVER_DASHBOARD_MANIFEST_RESET_PAGINATION = 'DRIVER_DASHBOARD_MANIFEST_RESET_PAGINATION'

export const DRIVER_MANIFEST = 'DRIVER_MANIFEST'
export const DRIVER_MANIFEST_CONDITION = 'DRIVER_MANIFEST_CONDITION'
export const DRIVER_MANIFEST_RESET_CONDITION = 'DRIVER_MANIFEST_RESET_CONDITION'
export const DRIVER_MANIFEST_RESET_PAGINATION = 'DRIVER_MANIFEST_RESET_PAGINATION'


export const DRIVER_SALES_DEAL_PAGINATION = 'DRIVER_SALES_DEAL_PAGINATION'
export const DRIVER_SALES_DEAL_RESET_PAGINATION = 'DRIVER_SALES_DEAL_RESET_PAGINATION'
export const DRIVER_SALES_DEAL_CONDITION = 'DRIVER_SALES_DEAL_CONDITION'
export const DRIVER_SALES_DEAL_RESET_CONDITION = 'DRIVER_SALES_DEAL_RESET_CONDITION'

export const DRIVER_SALES_REQUEST_PAGINATION = 'DRIVER_SALES_REQUEST_PAGINATION'
export const DRIVER_SALES_REQUEST_RESET_PAGINATION = 'DRIVER_SALES_REQUEST_RESET_PAGINATION'
export const DRIVER_SALES_REQUEST_CONDITION = 'DRIVER_SALES_REQUEST_CONDITION'
export const DRIVER_SALES_REQUEST_RESET_CONDITION = 'DRIVER_SALES_REQUEST_RESET_CONDITION'

export const DRIVER_SALES_REQUEST_DETAIL_PAGINATION = 'DRIVER_SALES_REQUEST_DETAIL_PAGINATION'
export const DRIVER_SALES_REQUEST_DETAIL_RESET_PAGINATION = 'DRIVER_SALES_REQUEST_DETAIL_RESET_PAGINATION'
export const DRIVER_SALES_REQUEST_DETAIL_CONDITION = 'DRIVER_SALES_REQUEST_DETAIL_CONDITION'
export const DRIVER_SALES_REQUEST_DETAIL_RESET_CONDITION = 'DRIVER_SALES_REQUEST_DETAIL_RESET_CONDITION'

export const DRIVER_SALES_FREEE_TRANSACTION_BILLING_PAGINATION = 'DRIVER_SALES_FREEE_TRANSACTION_BILLING_PAGINATION'
export const DRIVER_SALES_FREEE_TRANSACTION_BILLING_RESET_PAGINATION = 'DRIVER_SALES_FREEE_TRANSACTION_BILLING_RESET_PAGINATION'
export const DRIVER_SALES_FREEE_TRANSACTION_BILLING_CONDITION = 'DRIVER_SALES_FREEE_TRANSACTION_BILLING_CONDITION'
export const DRIVER_SALES_FREEE_TRANSACTION_BILLING_RESET_CONDITION = 'DRIVER_SALES_FREEE_TRANSACTION_BILLING_RESET_CONDITION'

export const DRIVER_EMISSION_MANAGEMENT = 'DRIVER_MANAGEMENT_EMISSION'
export const DRIVER_EMISSION_MANAGEMENT_CONDITION = 'DRIVER_EMISSION_MANAGEMENT_CONDITION'
export const DRIVER_EMISSION_MANAGEMENT_RESET_CONDITION = 'DRIVER_EMISSION_MANAGEMENT_RESET_CONDITION'

export const DRIVER_NOTIFICATION = 'DRIVER_NOTIFICATION'
export const DRIVER_NOTIFICATION_CONDITION = 'DRIVER_NOTIFICATION_CONDITION'
export const DRIVER_NOTIFICATION_RESET_CONDITION = 'DRIVER_NOTIFICATION_RESET_CONDITION'
export const DRIVER_NOTIFICATION_COUNT = 'DRIVER_NOTIFICATION_COUNT'

export const DRIVER_MANIFEST_MANAGEMENT_PAGINATION = 'DRIVER_MANIFEST_MANAGEMENT_PAGINATION'
export const DRIVER_MANIFEST_MANAGEMENT_RESET_PAGINATION = 'DRIVER_MANIFEST_MANAGEMENT_RESET_PAGINATION'
export const DRIVER_MANIFEST_MANAGEMENT_CONDITION = 'DRIVER_MANIFEST_MANAGEMENT_CONDITION'
export const DRIVER_MANIFEST_MANAGEMENT_RESET_CONDITION = 'DRIVER_MANIFEST_MANAGEMENT_RESET_CONDITION'

export const DRIVER_MANIFEST_MANAGEMENT_TAB = 'DRIVER_MANIFEST_MANAGEMENT_TAB'
export const DRIVER_MANIFEST_MANAGEMENT_RESET_TAB = 'DRIVER_MANIFEST_MANAGEMENT_RESET_TAB'

export const DRIVER_MANIFEST_REQUEST_PAGINATION = 'DRIVER_MANIFEST_REQUEST_PAGINATION'
export const DRIVER_MANIFEST_REQUEST_RESET_PAGINATION = 'DRIVER_MANIFEST_REQUEST_RESET_PAGINATION'
export const DRIVER_MANIFEST_REQUEST_CONDITION = 'DRIVER_MANIFEST_REQUEST_CONDITION'
export const DRIVER_MANIFEST_REQUEST_RESET_CONDITION = 'DRIVER_MANIFEST_REQUEST_RESET_CONDITION'

export const DRIVER_MANIFEST_REQUEST_SET_ITEM = 'DRIVER_MANIFEST_REQUEST_SET_ITEM'
export const DRIVER_MANIFEST_REQUEST_REMOVE_ITEM = 'DRIVER_MANIFEST_REQUEST_REMOVE_ITEM'
export const DRIVER_MANIFEST_REQUEST_ALL_REMOVE_ITEMS = 'DRIVER_MANIFEST_REQUEST_ALL_REMOVE_ITEMS'

export const DRIVER_MANIFEST_MAP_REQUEST_PAGINATION = 'DRIVER_MANIFEST_MAP_REQUEST_PAGINATION'
export const DRIVER_MANIFEST_MAP_REQUEST_RESET_PAGINATION = 'DRIVER_MANIFEST_MAP_REQUEST_RESET_PAGINATION'
export const DRIVER_MANIFEST_MAP_REQUEST_CONDITION = 'DRIVER_MANIFEST_MAP_REQUEST_CONDITION'
export const DRIVER_MANIFEST_MAP_REQUEST_RESET_CONDITION = 'DRIVER_MANIFEST_MAP_REQUEST_RESET_CONDITION'

export const DRIVER_MANIFEST_LINKAGE_PAGINATION = 'DRIVER_MANIFEST_LINKAGE_PAGINATION'
export const DRIVER_MANIFEST_LINKAGE_RESET_PAGINATION = 'DRIVER_MANIFEST_LINKAGE_RESET_PAGINATION'
export const DRIVER_MANIFEST_LINKAGE_CONDITION = 'DRIVER_MANIFEST_LINKAGE_CONDITION'
export const DRIVER_MANIFEST_LINKAGE_RESET_CONDITION = 'DRIVER_MANIFEST_LINKAGE_RESET_CONDITION'
export const DRIVER_MANIFEST_LINKAGE_REMOVE_ITEM = 'DRIVER_MANIFEST_LINKAGE_REMOVE_ITEM'
export const DRIVER_MANIFEST_LINKAGE_ALL_REMOVE_ITEMS = 'DRIVER_MANIFEST_LINKAGE_ALL_REMOVE_ITEMS'

/** 個別チェック情報の保持 */
export const DRIVER_MANIFEST_LINKAGE_INDIVIDUAL_SET_ITEM = 'DRIVER_MANIFEST_LINKAGE_INDIVIDUAL_SET_ITEM'

/** 個別チェック情報の削除 */
export const DRIVER_MANIFEST_LINKAGE_INDIVIDUAL_REMOVE_ITEM = 'DRIVER_MANIFEST_LINKAGE_INDIVIDUAL_REMOVE_ITEM'

/** 紐付け保守 */
export const DRIVER_MANIFEST_PREVIOUSLY_REMOVE_ITEM = 'DRIVER_MANIFEST_PREVIOUSLY_REMOVE_ITEM'
export const DRIVER_MANIFEST_PREVIOUSLY_ALL_REMOVE_ITEMS = 'DRIVER_MANIFEST_PREVIOUSLY_ALL_REMOVE_ITEMS'

export const DRIVER_MANIFEST_PREVIOUSLY_INDIVIDUAL_SET_ITEM = 'DRIVER_MANIFEST_PREVIOUSLY_INDIVIDUAL_SET_ITEM'
export const DRIVER_MANIFEST_PREVIOUSLY_INDIVIDUAL_REMOVE_ITEM = 'DRIVER_MANIFEST_PREVIOUSLY_INDIVIDUAL_REMOVE_ITEM'
export const DRIVER_MANIFEST_PREVIOUSLY_INDIVIDUAL_CLEAR_ITEM = 'DRIVER_MANIFEST_PREVIOUSLY_INDIVIDUAL_CLEAR_ITEM'

export const DRIVER_MANIFEST_TARGET_CHECKED_ITEMS = 'DRIVER_MANIFEST_TARGET_CHECKED_ITEMS'


export const DRIVER_ITEM_PAGINATION = 'DRIVER_ITEM_PAGINATION'
export const DRIVER_ITEM_CONDITION = 'DRIVER_ITEM_CONDITION'
export const DRIVER_ITEM_RESET_PAGINATION = 'DRIVER_ITEM_RESET_PAGINATION'
export const DRIVER_ITEM_RESET_CONDITION = 'DRIVER_ITEM_RESET_CONDITION'

export const DRIVER_EMISSION = 'DRIVER_EMISSION'
export const DRIVER_EMISSION_CONDITION = 'DRIVER_EMISSION_CONDITION'
export const DRIVER_EMISSION_RESET_CONDITION = 'DRIVER_EMISSION_RESET_CONDITION'
export const DRIVER_EMISSION_RESET_PAGINATION = 'DRIVER_EMISSION_RESET_PAGINATION'

export const DRIVER_USER = 'DRIVER_USER'
export const DRIVER_USER_CONDITION = 'DRIVER_USER_CONDITION'
export const DRIVER_USER_RESET_CONDITION = 'DRIVER_USER_RESET_CONDITION'
export const DRIVER_USER_RESET_PAGINATION = 'DRIVER_USER_RESET_PAGINATION'

export const DRIVER_TRANSPORT = 'DRIVER_TRANSPORT'
export const DRIVER_TRANSPORT_CONDITION = 'DRIVER_TRANSPORT_CONDITION'
export const DRIVER_TRANSPORT_RESET_CONDITION = 'DRIVER_TRANSPORT_RESET_CONDITION'

export const DRIVER_DISPOSER = 'DRIVER_DISPOSER'
export const DRIVER_DISPOSER_CONDITION = 'DRIVER_DISPOSER_CONDITION'
export const DRIVER_DISPOSER_RESET_CONDITION = 'DRIVER_DISPOSER_RESET_CONDITION'

// 収運処分業者
export const DRIVER_TRADER = 'DRIVER_TRADER'
export const DRIVER_TRADER_CONDITION = 'DRIVER_TRADER_CONDITION'
export const DRIVER_TRADER_RESET_CONDITION = 'DRIVER_TRADER_RESET_CONDITION'


export const DRIVER_TRANSPORT_ROUTE_CONDITION = 'DRIVER_MASTER_TRANSPORT_ROUTE_CONDITION'
export const DRIVER_TRANSPORT_ROUTE_RESET_CONDITION = 'DRIVER_TRANSPORT_ROUTE_RESET_CONDITION'
export const DRIVER_TRANSPORT_ROUTE_PAGINATION = 'DRIVER_TRANSPORT_ROUTE_PAGINATION'
export const DRIVER_TRANSPORT_ROUTE_RESET_PAGINATION = 'DRIVER_TRANSPORT_ROUTE_RESET_PAGINATION'

// 最終処分場
export const DRIVER_FINALDISPOSALSITE_PAGINATION = 'DRIVER_FINALDISPOSALSITE_PAGINATION'
export const DRIVER_FINALDISPOSALSITE_CONDITION = 'DRIVER_FINALDISPOSALSITE_CONDITION'
export const DRIVER_FINALDISPOSALSITE_RESET_PAGINATION = 'DRIVER_FINALDISPOSALSITE_RESET_PAGINATION'
export const DRIVER_FINALDISPOSALSITE_RESET_CONDITION = 'DRIVER_FINALDISPOSALSITE_RESET_CONDITION'

// 公共積替
export const DRIVER_PUBLICPLACE_PAGINATION = 'DRIVER_PUBLICPLACEE_PAGINATION'
export const DRIVER_PUBLICPLACE_CONDTION = 'DRIVER_PUBLICPLACEE_CONDTION'
export const DRIVER_PUBLICPLACE_RESET_CONDTION = 'DRIVER_PUBLICPLACEE_RESET_CONDTION'
export const DRIVER_PUBLICPLACE_RESET_PAGINATION = 'DRIVER_PUBLICPLACE_RESET_PAGINATION'

// JWNET未加入業者
export const DRIVER_NON_SUBSCRIBE_TRADER = 'DRIVER_NON_SUBSCRIBE_TRADER'
export const DRIVER_NON_SUBSCRIBE_TRADER_CONDITION = 'DRIVER_NON_SUBSCRIBE_TRADER_CONDITION'
export const DRIVER_NON_SUBSCRIBE_TRADER_RESET_CONDITION = 'DRIVER_NON_SUBSCRIBE_TRADER_RESET_CONDITION'
export const DRIVER_NON_SUBSCRIBE_TRADER_RESET_PAGINATION = 'DRIVER_NON_SUBSCRIBE_TRADER_RESET_PAGINATION'

// 報告不要業者
export const DRIVER_NON_REPORTING_TRADER = 'DRIVER_NON_REPORTING_TRADER'
export const DRIVER_NON_REPORTING_TRADER_CONDITION = 'DRIVER_NON_REPORTING_TRADER_CONDITION'
export const DRIVER_NON_REPORTING_TRADER_RESET_CONDITION = 'DRIVER_NON_REPORTING_TRADER_RESET_CONDITION'
export const DRIVER_NON_REPORTING_TRADER_RESET_PAGINATION = 'DRIVER_NON_REPORTING_TRADER_RESET_PAGINATION'

//請求先
export const DRIVER_BILLING_ADDRESS = 'DRIVER_BILLING_ADDRESS'
export const DRIVER_BILLING_ADDRESS_CONDITION = 'DRIVER_BILLING_ADDRESS_CONDITION'
export const DRIVER_BILLING_ADDRESS_RESET_CONDITION = 'DRIVER_BILLING_ADDRESS_RESET_CONDITION'
export const DRIVER_BILLING_ADDRESS_RESET_PAGINATION = 'DRIVER_BILLING_ADDRESS_RESET_PAGINATION'

// 車両
export const DRIVER_VEHICLE = 'DRIVER_VEHICLE'
export const DRIVER_VEHICLE_CONDITION = 'DRIVER_VEHICLE_CONDITION'
export const DRIVER_VEHICLE_RESET_CONDITION = 'DRIVER_VEHICLE_RESET_CONDITION'
export const DRIVER_VEHICLE_RESET_PAGINATION = 'DRIVER_VEHICLE_RESET_PAGINATION'

// 一般廃棄物品目
export const DRIVER_GENERAL_ITEM = 'DRIVER_GENERAL_ITEM'
export const DRIVER_GENERAL_ITEM_RESET_PAGINATION = 'DRIVER_GENERAL_ITEM_RESET_PAGINATION'

export const DRIVER_SALES_ITEM_UNIT_PAGINATION = 'DRIVER_SALES_ITEM_UNIT_PAGINATION'
export const DRIVER_SALES_ITEM_UNIT_CONDITION = 'DRIVER_SALES_ITEM_UNIT_CONDITION'
export const DRIVER_SALES_ITEM_UNIT_RESET_PAGINATION = 'DRIVER_SALES_ITEM_UNIT_RESET_PAGINATION'
export const DRIVER_SALES_ITEM_UNIT_RESET_CONDITION = 'DRIVER_SALES_ITEM_UNIT_RESET_CONDITION'


export const DRIVER_DISPOSAL_FLOW = 'DRIVER_DISPOSAL_FLOW'
export const DRIVER_DISPOSAL_FLOW_CONDITION = 'DRIVER_DISPOSAL_FLOW_CONDITION'
export const DRIVER_DISPOSAL_FLOW_RESET_CONDITION = 'DRIVER_DISPOSAL_FLOW_RESET_CONDITION'

// テナント設定
export const DRIVER_TENANT_CONFIGURATION = 'DRIVER_TENANT_CONFIGURATION'

export const DRIVER_SALES_ITEM_PRICE_CONDITION = 'DRIVER_SALES_ITEM_PRICE_CONDITION'
export const DRIVER_SALES_ITEM_PRICE_PAGINATION = 'DRIVER_SALES_ITEM_PRICE_PAGINATION'
export const DRIVER_SALES_ITEM_PRICE_RESET_PAGINATION = 'DRIVER_SALES_ITEM_PRICE_RESET_PAGINATION'
export const DRIVER_SALES_ITEM_PRICE_RESET_CONDITION = 'DRIVER_SALES_ITEM_PRICE_RESET_CONDITION'

export const DRIVER_ORDER_ACCEPT_PAGINATION = 'DRIVER_ORDER_ACCEPT_PAGINATION'
export const DRIVER_ORDER_ACCEPT_RESET_PAGINATION = 'DRIVER_ORDER_ACCEPT_RESET_PAGINATION'
export const DRIVER_ORDER_ACCEPT_CONDITION = 'DRIVER_ORDER_ACCEPT_CONDITION'
export const DRIVER_ORDER_ACCEPT_RESET_CONDITION = 'DRIVER_ORDER_ACCEPT_RESET_CONDITION'
export const DRIVER_ORDER_ACCEPT_SELECTABLE_TAB = 'DRIVER_ORDER_ACCEPT_SELECTABLE_TAB'
export const DRIVER_ORDER_ACCEPT_RESET_TAB = 'DRIVER_ORDER_ACCEPT_RESET_TAB'

export const DRIVER_ORDER_REQUEST_PAGINATION = 'DRIVER_ORDER_REQUEST_PAGINATION'
export const DRIVER_ORDER_REQUEST_RESET_PAGINATION = 'DRIVER_ORDER_REQUEST_RESET_PAGINATION'
export const DRIVER_ORDER_REQUEST_CONDITION = 'DRIVER_ORDER_REQUEST_CONDITION'
export const DRIVER_ORDER_REQUEST_RESET_CONDITION = 'DRIVER_ORDER_REQUEST_RESET_CONDITION'

export const DRIVER_ORDER_RECEIVE_CONDITION = 'DRIVER_ORDER_RECEIVE_CONDITION'
export const DRIVER_ORDER_RECEIVE_RESET_CONDITION = 'DRIVER_ORDER_RECEIVE_RESET_CONDITION'
export const DRIVER_ORDER_RECEIVE_RESET_PAGINATION = 'DRIVER_ORDER_RECEIVE_RESET_PAGINATION'
export const DRIVER_ORDER_RECEIVE_PAGINATION = 'DRIVER_ORDER_RECEIVE_PAGINATION'

export const DRIVER_MANIFEST_REQUEST_PICKUP_PAGINATION = 'DRIVER_MANIFEST_REQUEST_PICKUP_PAGINATION'

export const DRIVER_MANIFEST_REQUEST_CARRYIN_PAGINATION = 'DRIVER_MANIFEST_REQUEST_CARRYIN_PAGINATION'

export const DRIVER_ACCEPTANCE_PAGINATION = 'DRIVER_ACCEPTANCE_PAGINATION'
export const DRIVER_ACCEPTANCE_CONDITION = 'DRIVER_ACCEPTANCE_CONDITION'
export const DRIVER_ACCEPTANCE_RESET_CONDITION = 'DRIVER_ACCEPTANCE_RESET_CONDITION'

export const DRIVER_CONVERSION_FACTOR_DETAIL_PAGINATION = 'DRIVER_CONVERSION_FACTOR_DETAIL_PAGINATION'
export const DRIVER_CONVERSION_FACTOR_DETAIL_RESET_PAGINATION = 'DRIVER_CONVERSION_FACTOR_DETAIL_RESET_PAGINATION'
export const DRIVER_CONVERSION_FACTOR_DETAIL_RESET_CONDITION = 'DRIVER_CONVERSION_FACTOR_DETAIL_RESET_CONDITION'

export const DRIVER_RECYCLE_CONVERSION_FACTOR_DETAIL_PAGINATION = 'DRIVER_RECYCLE_CONVERSION_FACTOR_DETAIL_PAGINATION'
export const DRIVER_RECYCLE_CONVERSION_FACTOR_DETAIL_RESET_PAGINATION = 'DRIVER_RECYCLE_CONVERSION_FACTOR_DETAIL_RESET_PAGINATION'
export const DRIVER_RECYCLE_CONVERSION_FACTOR_DETAIL_RESET_CONDITION = 'DRIVER_RECYCLE_CONVERSION_FACTOR_DETAIL_RESET_CONDITION'

export const DRIVER_PROVIDER_SETTING_RELEASE = "DRIVER_PROVIDER_SETTING_RELEASE"
export const DRIVER_PROVIDER_SETTING_REFLECTION = "DRIVER_PROVIDER_SETTING_REFLECTION"

export const DRIVER_TRANSFER_CONDITION = "DRIVER_TRANSFER_CONDITION"

export const DRIVER_TRANSFER_PAGINATION = "DRIVER_TRANSFER_PAGINATION"

export const DRIVER_TRANSFER_RESET_CONDITION = "DRIVER_TRANSFER_RESET_CONDITION"

export const DRIVER_TRANSFER_RESET_PAGINATION = "DRIVER_TRANSFER_RESET_PAGINATION"

export const DRIVER_GENERAL_WASTE_DISPOSAL_CONDITION = 'DRIVER_GENERAL_WASTE_DISPOSAL_CONDITION'
export const DRIVER_GENERAL_WASTE_DISPOSAL_PAGINATION = 'DRIVER_GENERAL_WASTE_DISPOSAL_PAGINATION'
export const DRIVER_GENERAL_WASTE_DISPOSAL_RESET_CONDITION = 'DRIVER_GENERAL_WASTE_DISPOSAL_RESET_CONDITION'
export const DRIVER_GENERAL_WASTE_DISPOSAL_RESET_PAGINATION = 'DRIVER_GENERAL_WASTE_DISPOSAL_RESET_PAGINATION'

export const DRIVER_MASTER_RECYCLE_DISPOSAL_METHOD_CONDITION = 'DRIVER_MASTER_RECYCLE_DISPOSAL_METHOD_CONDITION'
export const DRIVER_MASTER_RECYCLE_DISPOSAL_METHOD_PAGINATION = 'DRIVER_MASTER_RECYCLE_DISPOSAL_METHOD_PAGINATION'
export const DRIVER_MASTER_RECYCLE_DISPOSAL_METHOD_RESET_CONDITION = 'DRIVER_MASTER_RECYCLE_DISPOSAL_METHOD_RESET_CONDITION'
export const DRIVER_MASTER_RECYCLE_DISPOSAL_METHOD_RESET_PAGINATION = 'DRIVER_MASTER_RECYCLE_DISPOSAL_METHOD_RESET_PAGINATION'

export const DRIVER_MASTER_RECYCLE_DISPOSAL_PATTERN_CONDITION = 'DRIVER_MASTER_RECYCLE_DISPOSAL_PATTERN_CONDITION'
export const DRIVER_MASTER_RECYCLE_DISPOSAL_PATTERN_RESET_CONDITION = 'DRIVER_MASTER_RECYCLE_DISPOSAL_PATTERN_RESET_CONDITION'
